var _rect, _path, _path2, _path3, _path4, _rect2, _mask, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 146,
    viewBox: "0 0 108 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18,
    width: 104,
    height: 118,
    rx: 14,
    stroke: "#757575",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 32V123",
    stroke: "#757575",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 32V123",
    stroke: "#757575",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32V123",
    stroke: "#757575",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 32V123",
    stroke: "#757575",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 2,
    width: 35,
    height: 16,
    stroke: "#757575",
    strokeWidth: 4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_167_5900",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 134H89V146H16V134Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 134V130H12V134H16ZM89 134H93V130H89V134ZM16 138H89V130H16V138ZM85 134V146H93V134H85ZM20 146V134H12V146H20Z",
    fill: "#757575",
    mask: "url(#path-7-inside-1_167_5900)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H86",
    stroke: "#757575",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseIcon);
export default __webpack_public_path__ + "static/media/suitcaseIcon.e26fc2c236dc39c75eded676c5d562d5.svg";
export { ForwardRef as ReactComponent };